//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab, Badge} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../assets/styles/colors';

export type SwitchTabLabel = {
  label: string,
  badge?: string,
  value?: string,
};
type Props = {|
  value: string,
  onChange?: (event: SyntheticEvent<{}>) => void,
  labels: SwitchTabLabel[],
|};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    backgroundColor: colors.grey300,
    borderRadius: '40px',
    padding: '6px',
    minHeight: 32,
    width: '100%',
    maxWidth: '350px',
    overflow: 'visible',
  },
  customTab: {
    fontSize: '0.875rem',
    fontWeight: 500,
    overflow: 'visible',
    // color: colors.grey600,
    textTransform: 'none',
    height: 32,
    minWidth: 20,
    minHeight: '20px',
    // padding: '0 16px',
    // margin: '4px',
    flexGrow: 1,
  },
  activeTab: {
    fontWeight: 600,
    // color: colors.grey900,
    backgroundColor: 'white',
    borderRadius: '124px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16)',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  badge: {
    backgroundColor: colors.success,
    color: 'white',
    fontSize: '10px',
    fontWeight: 600,
    padding: '0 8px',
    borderRadius: '8px',
    transform: 'scale(1) translate(70%, -50%)',
  },
  scroller: {
    overflow: 'visible !important',
  },
  badgeRoot: {
    width: '100%',
    justifyContent: 'center',
  },
}));

export default function SwitchTabs(props: Props) {
  const {value, onChange, labels} = props;
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{
        indicator: classes.indicator,
        scroller: classes.scroller,
      }}
      // textColor="primary"
      className={classes.tabs}
      // variant="scrollable"
    >
      {labels.map(({badge, label, value}) => {
        return (
          <Tab
            key={label}
            label={
              <Badge
                Badge
                invisible={!badge}
                badgeContent={badge}
                classes={{badge: classes.badge, root: classes.badgeRoot}}
              >
                {label}
              </Badge>
            }
            classes={{
              root: classes.customTab,
              selected: classes.activeTab,
            }}
            value={value}
          />
        );
      })}
    </Tabs>
  );
}

SwitchTabs.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  labels: PropTypes.array,
};
